export const SEARCH_FEATURE_KEY = 'search';
export const SEARCH_LOCALIZATION_SCOPE = 'search-nav';
export const SEARCH_DEBOUNCE_TIME_MS = 250;
